export default class UnSupportedMediaTypeError extends Error {
	public constructor() {
		super();
	}
}
